module["exports"] = [
  "gmail.com",
  "yahoo.com",
  "hotmail.com"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/es/internet/free_email.js
 ** module id = 603
 ** module chunks = 0
 **/